import { createStore, } from '@zedux/core';
import { pluginActions } from '../utils/plugin-actions.js';
export class ZeduxPlugin {
    constructor({ initialMods = [], registerEcosystem, } = {}) {
        this.modStore = createStore(null, initialMods);
        this.registerEcosystem = registerEcosystem || (() => { });
    }
}
/**
 * These actions should only be dispatched to an ecosystem's modBus
 * store, so they don't need prefixes
 */
ZeduxPlugin.actions = pluginActions;
